import { contactContent } from '@/mocks/home';

export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {contactContent.title}
          </h2>
          <p className="mt-3 max-w-2xl mx-auto text-sm md:text-base text-foreground-600 leading-relaxed">
            {contactContent.description}
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {contactContent.methods.map((method, idx) => {
              const iconBg =
                idx === 0
                  ? 'bg-primary-500'
                  : idx === 1
                  ? 'bg-accent-500'
                  : 'bg-secondary-500';

              return (
                <div key={method.name} className="text-center p-5 rounded-xl bg-background-100 border border-background-200/70">
                  <div className={`w-12 h-12 mx-auto flex items-center justify-center rounded-xl ${iconBg} text-white`}>
                    <i className={`${method.icon} text-xl`}></i>
                  </div>
                  <h3 className="mt-4 font-heading font-bold text-foreground-900 text-base md:text-lg">
                    {method.name}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600">
                    {method.value}
                  </p>
                </div>
              );
            })}
          </div>

          <div className="mt-8 pt-6 border-t border-background-200/70 text-center">
            <p className="text-xs md:text-sm text-foreground-500">
              我们承诺对所有爆料人的身份信息严格保密。重大独家爆料一经核实发布，将按内容价值给予丰厚线索奖励。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}